import { EventEmitter, Injectable, TemplateRef, Type } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AlertModalComponent } from './alert-modal/alert-modal.component';

@Injectable({
  providedIn: 'root'
})
export class PopupService {

  private popup: BsModalRef;

  constructor(private modalService: BsModalService,) { }

  public Open(component: Type<any>, state: PopupOptions): BsModalRef;
  public Open(template: TemplateRef<any>, state: PopupOptions): BsModalRef;
  public Open(message: string, state: PopupOptions): BsModalRef;
  public Open(content: string | TemplateRef<any> | Type<any>, state: PopupOptions = {}): BsModalRef {

    const initialState: { Template?: TemplateRef<any>, Message?: string, Component?: Type<any> } = {};

    if (content instanceof TemplateRef) {
      initialState.Template = content;
    } else if (typeof (content) === 'string') {
      initialState.Message = content;
    } else if (typeof content === 'function') {
      initialState.Component = content;
    }

    return this.popup = this.modalService.show(AlertModalComponent, { initialState: Object.assign(initialState, state) });
  }

  public ClosePopup() {
    this.popup.hide();
  }
}

export interface PopupOptions {
  Title?: string,
  OnClose?: EventEmitter<void>,
  ngClass?: any,
  CloseText?: string,
  CanClose?: boolean
}
